module.exports = __webpack_public_path__ + "img/netherlands_icc.f4e243c3.png";